// A hash of the built stylesheet. The bundle build defines it in Libraries/src/mvdmio.ASP.Razor/mvdmio.ASP.Razor.csproj,
// and Libraries/test/mvdmio.ASP.Razor.Tests.Unit/vitest.config.ts defines it with a fixed value.
declare const RICH_TEXT_EDITOR_SKIN_VERSION: string;

// The editor's stylesheet (the Oxide skin plus the sink fix), built from rich-text-editor-skin.input.css
// beside the bundle. The URL resolves against this module, which sits in the same folder as the
// built file in source and in the bundle alike. The stylesheet keeps its file name, so the address carries
// the hash of its content and a changed stylesheet reaches every browser on its next view.
const SKIN_URL = `${new URL("./rich-text-editor-skin.css", import.meta.url).href}?v=${RICH_TEXT_EDITOR_SKIN_VERSION}`;

// One load per link, so every editor on a page waits on the load the first editor started.
const skinLoads = new WeakMap<HTMLLinkElement, Promise<void>>();

/**
 * Adds the editor's stylesheet to `<head>` once and resolves when it has loaded. A link already
 * in `<head>` (a second editor, a later Turbo visit) is reused: its pending load is awaited, and
 * a finished one resolves at once. A failed load rejects and removes the link, so no dead link stays.
 */
export function loadRichTextEditorSkin(): Promise<void> {
    const existing = [...document.head.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')]
        .find((link) => link.href === SKIN_URL);
    if (existing) return skinLoads.get(existing) ?? Promise.resolve();

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = SKIN_URL;
    const load = new Promise<void>((resolve, reject) => {
        link.addEventListener("load", () => resolve(), { once: true });
        link.addEventListener("error", () => {
            link.remove();
            reject(new Error(`The editor stylesheet at ${SKIN_URL} did not load.`));
        }, { once: true });
    });
    skinLoads.set(link, load);
    document.head.appendChild(link);
    return load;
}
